module.exports = __webpack_public_path__ + "img/edelstahltopf.c64cc658.jpg";